import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig, MatSnackBarRef, MatSnackBar, MatSnackBarHorizontalPosition } from '@angular/material/snack-bar';
import { AlertComponent } from '../dialogs/alert.component';
import { Multimedia } from '../_models/comparador/multimedia';
import { MultimediaComponent } from '../comparador/components/multimedia/multimedia.component';
import { BorrarArchivoDialog } from '../dialogs/comparador/borrar-archivo/borrar-archivo.dialog';
import { SnackBarInfoComponent } from '../dialogs/snackbar-info/snackbar-info.component';

@Injectable()
export class SnackBarService {
	constructor(private snackBar: MatSnackBar, private dialog: MatDialog) {}

	/**
	 * Abre un snackBar con los parámetros dados
	 * @function
	 * @param {boolean} status - Determina el estado que representa el snackBar
	 * @param {string} titulo - Titulo a mostrar
	 * @param {string} mensaje - Mensaje en el interior de la barra
	 * @param {boolean} action - Acción
	 * @param {number} duration - Duración de la barra
	 */
	openSnackBar(
		status: boolean,
		titulo: string,
		mensaje: string,
		action: boolean,
		duration: number,
		horizontalPosition: MatSnackBarHorizontalPosition = 'center'
	): void {
		let config = new MatSnackBarConfig();
		if (duration != null) {
			config.duration = duration;
		}
		config.horizontalPosition = horizontalPosition;
		let snackRef: MatSnackBarRef<AlertComponent> = this.snackBar.openFromComponent(
			AlertComponent,
			config
		);
		snackRef.instance.status = status;
		snackRef.instance.mensaje = mensaje;
		snackRef.instance.action = action;
		snackRef.instance.titulo = titulo;
		snackRef.instance.snackBarRef = snackRef;
	}
}
